import { createContext, type ReactNode } from 'react';
import type { ApprovalOperation } from 'ui-product-approvals-common';

export interface ApprovalOperationPanelContextValue {
  alertContent?: ReactNode;
  onClose: () => void;
  onRequestSuccess?: (currentOperation?: ApprovalOperation) => void;
  showFeedbackSurvey: () => void;
  registerSidebar: () => () => void;
}

export const ApprovalOperationPanelContext = createContext<
  ApprovalOperationPanelContextValue | undefined
>(undefined);
